function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.938 9.969c.062-.063.125-.073.187-.031.083.041.125.104.125.187V16.5c0 .417-.146.77-.438 1.063S19.168 18 18.75 18h-13c-.417 0-.77-.146-1.063-.438s-.437-.645-.437-1.062v-6.375c0-.083.031-.135.094-.156.083-.042.156-.042.218 0 .688.52 2.292 1.698 4.813 3.531a8.6 8.6 0 00.406.344c.25.187.448.333.594.437.146.084.333.198.563.344.229.125.447.219.656.281.229.063.448.094.656.094.188 0 .375-.02.563-.063.187-.062.364-.124.53-.187.167-.083.344-.188.532-.313l.469-.312c.125-.104.27-.219.437-.344.167-.125.281-.219.344-.281 2.458-1.77 4.063-2.948 4.813-3.531zM12.25 14c-.167 0-.375-.052-.625-.156a32.87 32.87 0 01-.563-.313l-.656-.469c-.27-.229-.416-.343-.437-.343C7.427 10.865 5.615 9.52 4.53 8.688a.712.712 0 01-.281-.594V7.5c0-.417.146-.77.438-1.063S5.332 6 5.75 6h13c.417 0 .77.146 1.063.438s.437.645.437 1.062v.594c0 .25-.094.448-.281.594-1.021.791-2.834 2.135-5.438 4.03-.02 0-.177.115-.468.344-.271.209-.48.365-.625.47a12.59 12.59 0 01-.594.312c-.23.104-.427.156-.594.156z",
  fill: "#fff"
});

var SvgEnvelope = function SvgEnvelope(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgEnvelope;